<template>
  <div>
    <CapacityExceededBanner class="mb-6" :people="people" />

    <BaseButton
      color="red"
      size="large"
      class="w-full mb-4 flex items-center justify-center"
      data-test-id="enq-form-show-other-venues"
      @click="redirectToSearch"
    >
      Show venues for {{ people }} people

      <TagIcon
        :icon="OpenNewTabIcon"
        color="mono-white"
        class="ml-2"
      />
    </BaseButton>

    <BaseButton
      :is-loading="isEnquireBtnLoading"
      color="white"
      size="large"
      class="w-full flex items-center justify-center"
      data-test-id="enquiry-form__enquire-anyway"
      @click="$emit('continue')"
    >
      Continue anyway
    </BaseButton>

    <BackButton @click="back" />
  </div>
</template>

<script>
import OpenNewTabIcon from '@tagvenue/icons/24/bold/general/link-external-01.svg';
import { markRaw } from 'vue';
import { mapState } from 'vuex';

import TagIcon from '@/components/TagIcon.vue';
import BaseButton from '@/components/Ui/Buttons/BaseButton.vue';

import BackButton from '../buttons/BackButton.vue';
import CapacityExceededBanner from './CapacityExceededBanner.vue';

export default {
  name: 'CapacityExceededWarning',
  emits: ['back', 'continue'],
  components: { BackButton, TagIcon, BaseButton, CapacityExceededBanner },

  props: {
    people: {
      type: [Number, null],
      required: true,
    },
    isEnquireBtnLoading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      OpenNewTabIcon: markRaw(OpenNewTabIcon),
    };
  },

  computed: {
    ...mapState([
      'form',
      'pages',
      'room',
    ]),
  },

  methods: {
    back() {
      if (this.$store.getters.roomPagesContextForTracking === 'enquire_now') {
        this.$store.dispatch('trackGA4Interaction', {
          section: 'capacity_exceeded',
          element: 'back_button',
          interaction: 'click',
        });
      }

      this.$store.dispatch('trackEnquiryFormBackNavigation', {
        label: 'back-from-capacity-warning',
      });
      this.$emit('back');
    },

    redirectToSearch() {
      this.$store.dispatch('trackFindSimilarVenues');

      if (window.location.href.includes('E2E_STOP_REDIRECTION')) {
        return;
      }
      this.$store.dispatch('trackEnquiryFormNavigation', { label: 'show-venues-for-people' });
      window.open(this.$store.getters.searchSimilarEventsUrl);
    },
  },
  mounted() {
    if (this.$store.getters.roomPagesContextForTracking === 'message_host') {
      this.$store.dispatch('trackGA4MessageHostInteraction', {
        section: 'event_info_step',
        element: 'number_of_people_capacity_exceeded_warning',
        interaction: 'visible',
      });
    } else {
      this.$store.dispatch('trackGA4Interaction', {
        section: 'event_info',
        element: 'number_of_people_capacity_exceeded_warning',
        value: null,
        interaction: 'visible',
      });
    }
  },
};
</script>

<style lang="scss" scoped>

</style>
